module.exports = __webpack_public_path__ + "img/kitty1.a209df31.jpg";